import React from 'react';
import { painPoints } from '../data/content';
import { RichText } from './RichText';
import { SectionHeading } from './SectionHeading';
export function ForYouSection() {
  return <section className="px-5 pb-6 pt-14 sm:px-6 md:px-8" data-id="element-83" data-mp="2cu80qptpvwq5">
      <div className="mx-auto max-w-[640px]" data-id="element-84" data-mp="2curdls4ifuxb">
        <SectionHeading eyebrow="Sound familiar?" data-id="element-85" data-mp="2ht1bwblj7bn5">This collection is for you if…</SectionHeading>

        <ul className="mt-7 space-y-5" data-id="element-86" data-mp="1l3bkrgcd1byn">
          {painPoints.map((line, index) => <li key={index} className="flex gap-3.5" data-id="element-87" data-mp="1p4ne9wycuhc4" data-mpi={index}>
              <span className="mt-[11px] h-1.5 w-1.5 shrink-0 rounded-full bg-sun-400" aria-hidden="true" data-id="element-88" data-mp="1p55hxencjxu2" />
              <p className="text-[16.5px] leading-[1.65] text-ink-800" data-id="element-89" data-mp="1z2jommjgx896">
                <RichText line={line} data-id="element-90" data-mp="1z0gm5314pmnk" />
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}